var exports = {
  "h": "Spacer__sEJ3t5",
};

module.exports = exports;
